import { ShieldCrossIcon } from './ShieldCrossIcon';

/**
 * author: Michael Irigoyen
 * id 8D47ED6A-831A-49F2-8E43-67F16F8351E6
 * name shield-cross
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-cross.svg
 * tags
 * - Gaming / RPG 
 * - Religion 
 */
export const ShieldChristianityIcon = ShieldCrossIcon;
export default ShieldChristianityIcon